import { Table as BootstrapTable } from "react-bootstrap";
import { DownArrowTable } from "../../../assets/icons/svgicons";
import NoContent from "../NoContent/NoContent";
import styles from "./Table.module.scss";
import TableLoading from "./TableLoading";

const Table = ({
  className, fields, children, loadingClassName, loading, noRecordVariant, noRecordClassName, noRecordContent, onClick,
}) => {
  return (
    <>
      {loading ? (
        <TableLoading fields={fields} className={loadingClassName} />
      ) : !children ? (
        <>
          <NoContent
            variant={noRecordVariant}
            content={noRecordContent}
            className={noRecordClassName}
          />
        </>
      ) : (
        <BootstrapTable
          responsive
          className={`${styles.table} ${className || ""}`}
        >
          {fields && (
            <thead>
              <tr>
                {fields.map((item) => (
                  <th key={item.label} className={item?.className}>
                    {item.label}
                    {item.sort && (
                      <button
                        className={`${styles.sort} ${false ? styles.active : ""
                          }`}
                        onClick={() => {
                          onClick(item.label);
                        }} /*  */
                      >
                        <DownArrowTable />
                      </button>
                    )}
                  </th>
                ))}
              </tr>
            </thead>
          )}
          <tbody>{children}</tbody>
        </BootstrapTable>
      )}
    </>
  );
};

export default Table;
